import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';

import { DyePenetrantInspectionItem } from '../../../utils/models';
import { getMTIColumns } from '../../../utils/data';
import { SURFACE_CONDITIONS } from '../custom-mpi/mpiReportForm';

import AutTable from '../../blocks/aut-grid-table';
import DyeInspectionItemForm from '../dpt/dyeInspectionItemForm';
import Form from '../../common/form';

class PAUTMTIForm extends Form {
	state = {
		data: {
			surfaceCondition: '',
			testStage: '',
			equipment: '',
			method: '',
			magneticMediumUsed: '',
			currentUsed: '',
			bgContrastMediumUsed: '',
			technique: '',
			refStd: '',
			acceptanceStd: '',
			material: '',
			data: [],
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		surfaceCondition: Joi.string().min(3).required().label('Surface Condition'),
		testStage: Joi.string().min(3).required().label('Stage of test'),
		equipment: Joi.string().min(3).required().label('Equipment'),
		method: Joi.string().min(3).required().label('Method'),
		magneticMediumUsed: Joi.string()
			.min(3)
			.required()
			.label('Magnetic Medium Used'),
		currentUsed: Joi.string().min(3).required().label('Current Used'),
		bgContrastMediumUsed: Joi.string()
			.min(3)
			.required()
			.label('Back ground contrast medium used'),
		technique: Joi.string().min(3).required().label('Technique'),
		refStd: Joi.string().min(3).required().label('Ref Std'),
		acceptanceStd: Joi.string().min(3).required().label('Acceptance Std'),
		material: Joi.string().min(3).required().label('Material'),
		data: Joi.array()
			.min(1)
			.items(
				Joi.object({
					srNo: Joi.number().positive().required().label('SR No'),
					itemInspected: Joi.string().min(3).required().label('Item Inspected'),
					size: Joi.number().min(1).required().label('Size (Inches)'),
					welderNo: Joi.string().required().label('Welder No'),
					observation: Joi.string().min(10).required().label('Observation'),
					result: Joi.string().min(3).required().label('Result'),
				})
			)
			.required()
			.label('Inspection Items'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({
			data: {
				surfaceCondition: '',
				testStage: '',
				equipment: '',
				method: '',
				magneticMediumUsed: '',
				currentUsed: '',
				bgContrastMediumUsed: '',
				technique: '',
				refStd: '',
				acceptanceStd: '',
				material: '',
				data: [],
			},
		});
	};

	onAddItem = (item: DyePenetrantInspectionItem) => {
		const data: any = { ...this.state.data };
		data.data = [...data.data];
		data.data.push({ ...item, srNo: this.state.data.data.length + 1 });

		this.setState({ data });
	};

	onDeleteItem = (item: DyePenetrantInspectionItem): void => {
		const data = { ...this.state.data };
		data.data = data.data.filter(
			(i: DyePenetrantInspectionItem) => i.srNo !== item.srNo
		);

		this.setState({ data });
	};

	render() {
		return (
			<React.Fragment>
				<DyeInspectionItemForm onAdd={this.onAddItem} />

				<div className="divider my-4"></div>

				<form autoComplete="off" onSubmit={this.handleSubmit}>
					<div className="row">
						<div className="col">
							{this.renderSelect({
								options: SURFACE_CONDITIONS,
								name: 'surfaceCondition',
								label: 'Surface Condition',
								placeholder: 'Enter Surface Condition',
							})}
						</div>

						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'testStage',
								label: 'Stage of Test',
								placeholder: 'Enter Stage of Test',
							})}
						</div>

						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'equipment',
								label: 'Equipment',
								placeholder: 'e.g. Enter Equipment',
							})}
						</div>

						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'method',
								label: 'Method',
								placeholder: 'Enter Inspection Method',
							})}
						</div>
					</div>

					<div className="divider my-4"></div>

					<div className="row">
						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'magneticMediumUsed',
								label: 'Magnetic Medium Used',
								placeholder: 'Enter Magnetic Medium Used',
							})}
						</div>

						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'currentUsed',
								label: 'Current Used',
								placeholder: 'Enter Current Used',
							})}
						</div>

						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'bgContrastMediumUsed',
								label: 'Background contrast medium used',
								placeholder: 'Enter Background contrast medium used',
							})}
						</div>
					</div>

					<div className="divider my-4"></div>

					<div className="row">
						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'technique',
								label: 'Technique',
								placeholder: 'Enter Technique',
							})}
						</div>

						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'refStd',
								label: 'Ref Standard',
								placeholder: 'Enter Ref Standard',
							})}
						</div>

						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'acceptanceStd',
								label: 'Acceptance Standard',
								placeholder: 'Enter Acceptance Standard',
							})}
						</div>

						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'material',
								label: 'Material',
								placeholder: 'Enter Material',
							})}
						</div>
					</div>

					{this.renderButton('Submit')}
				</form>

				<div className="divider my-4"></div>

				<AutTable
					tableColumns={getMTIColumns()}
					data={this.state.data.data}
					onDeleteItem={this.onDeleteItem}
				/>
			</React.Fragment>
		);
	}
}

export default PAUTMTIForm;
